import { createSlice } from '@reduxjs/toolkit';

// initial state
const initialState = {
  featured: false,
  search: '',
};

const filtersSlice = createSlice({
  name: 'filters',
  initialState,
  reducers: {
    filtered: (state, action) => {
      state.featured = action.payload;
    },
    searched: (state, action) => {
      state.search = action.payload;
    },
  },
});

export default filtersSlice.reducer;
export const { filtered, searched } = filtersSlice.actions;
